import { IconProps } from "../types/types";

const TikTokIcon = ({ className, size }: IconProps) => {
  return (
    <svg
      fill=""
      width={size}
      height={size}
      viewBox="0 0 0.438 0.438"
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="https://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M0.155 0.404c-0.035 -0.006 -0.069 -0.031 -0.083 -0.061a0.119 0.119 0 0 1 -0.012 -0.066c0.005 -0.042 0.026 -0.076 0.06 -0.095 0.018 -0.01 0.043 -0.015 0.062 -0.012l0.011 0.002 0 0.034V0.238l-0.01 0c-0.025 -0.001 -0.044 0.01 -0.053 0.031 -0.005 0.01 -0.006 0.028 -0.003 0.039 0.004 0.013 0.016 0.025 0.03 0.031 0.005 0.002 0.01 0.003 0.019 0.002 0.011 0 0.013 0 0.021 -0.004 0.011 -0.005 0.02 -0.013 0.025 -0.023 0.003 -0.006 0.004 -0.011 0.005 -0.022 0.001 -0.007 0.001 -0.069 0.001 -0.137L0.228 0.031h0.021c0.012 0 0.026 0 0.031 0.001l0.01 0.001v0.005c0 0.012 0.007 0.035 0.014 0.046 0.002 0.003 0.008 0.01 0.014 0.016 0.011 0.011 0.021 0.017 0.035 0.021 0.004 0.001 0.009 0.003 0.01 0.003s0.004 0.001 0.005 0.001 0.004 0 0.006 0.001l0.003 0.001v0.062l-0.006 -0.001c-0.03 -0.003 -0.054 -0.011 -0.073 -0.024 -0.01 -0.007 -0.01 -0.007 -0.009 -0.004 0 0.001 0 0.035 -0.001 0.076 -0.001 0.071 -0.001 0.075 -0.004 0.085 -0.011 0.038 -0.034 0.067 -0.066 0.078 -0.019 0.007 -0.044 0.009 -0.065 0.005z" />
    </svg>
  );
};

export default TikTokIcon;
